var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb p-0 m-0"},_vm._l((_vm.treeData),function(i){return _c('li',{key:i.id,staticClass:"breadcrumb-item"},[_vm._v("\n        "+_vm._s(i.label)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }